import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-choice-student',
  templateUrl: './choice-student.component.html',
  styleUrls: ['./choice-student.component.css']
})
export class ChoiceStudentComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }

  addInstitution() {
    this.router.navigate(['institution-list'])
  }

  myInstitution() {
    this.router.navigate(['student-dashboard'])
  }

}



// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/choice-student/choice-student.component.ts